
/* injects from baggage-loader */

'use strict';

import ProjectsComponent from './projects.component';

const ProjectsPageModule = angular.module('projects-module', [
    'ui.router'
  ])
  .config(($stateProvider, $urlRouterProvider) => {
    'ngInject';

    $urlRouterProvider.otherwise('/');

    $stateProvider
      .state('projects', {
        url: '/projects',
        component: 'projects',
        resolve: { 
          // The total number of projects on visible on the database
          totalProjectCount: function(Projects) {
            return Projects.count();
          },
          // The current page of projects
          projects: function(Projects) {
            return Projects.list({ skip: 0 });
          }
        }
      });
  })
  .component('projects', new ProjectsComponent());

export default ProjectsPageModule;



// WEBPACK FOOTER //
// ./src/app/pages/projects/projects.module.js